import { Stack, Typography } from '@mui/material';
import useColorsStyles from 'common/colors';
import useFlexBoxStyles from 'common/flexBox';
import useOnliveStyles from 'common/onliveStyles';
import * as moment from 'moment';
import { useTranslation } from 'react-i18next';
import 'suneditor/dist/css/suneditor.min.css';
import MyAvailabilityDayChips from './MyAvailabilityDayChips';

const MyAvailabilityDetails = ({ availability }) => {
    const { t } = useTranslation();
    const overrides = availability?.overrides;
    const unavailableDates = availability?.unavailableDates;
    const { classes: flexBox, cx } = useFlexBoxStyles();
    const { classes: onlive } = useOnliveStyles();
    const { classes: colors } = useColorsStyles();

    return (
        <Stack className={colors.bgNeutral100}>
            <Stack direction="column" spacing={2} className={flexBox.padding1}>
                <MyAvailabilityDayChips availability={availability} />
                <Stack direction="column" spacing={1}>
                    <Typography variant="subtitle1" fontWeight={600}>
                        {t('calendar.date.unavailableDates')}
                    </Typography>
                    <Stack direction="row" spacing={1}>
                        {unavailableDates.length ? (
                            unavailableDates.map((item, idx) => (
                                <Stack
                                    key={idx}
                                    direction="row"
                                    spacing={1}
                                    className={cx(
                                        onlive.borderMediumGray,
                                        flexBox.padding05,
                                        flexBox.borderRadius2,
                                        flexBox.margin05,
                                        colors.bgPaper,
                                    )}
                                >
                                    <Typography fontWeight={400} variant="subtitle2" noWrap>
                                        {moment(item[0]).format('DD / MM / YYYY')}
                                    </Typography>
                                    {/* <Typography fontWeight={400} variant="subtitle2">
                                            {t('services.form.dateTo')}
                                        </Typography> */}
                                    <Typography fontWeight={400} variant="subtitle2" noWrap>
                                        -
                                    </Typography>
                                    <Typography fontWeight={400} variant="subtitle2" noWrap>
                                        {moment(item[1]).format('DD / MM / YYYY')}
                                    </Typography>
                                </Stack>
                            ))
                        ) : (
                            <Typography fontWeight={400} variant="subtitle2" noWrap>
                                {t('analytics.common.noData')}
                            </Typography>
                        )}
                    </Stack>
                </Stack>
                <Stack direction="column" spacing={1}>
                    <Typography variant="subtitle1" fontWeight={600}>
                        {t('calendar.dateOverride')}
                    </Typography>
                    <Stack direction="column" spacing={2}>
                        {Object.keys(overrides)?.length ? (
                            Object.keys(overrides)?.map((key) => (
                                <Stack direction="column" key={key} spacing={1}>
                                    <Typography variant="subtitle2" fontWeight={600}>
                                        {moment(key).format('DD / MM / YYYY')} :
                                    </Typography>
                                    <Stack direction="row" flexWrap="wrap">
                                        {overrides[key]?.map((hour, idx) => (
                                            <Stack
                                                key={idx}
                                                direction="row"
                                                spacing={1}
                                                className={cx(
                                                    onlive.borderMediumGray,
                                                    flexBox.padding05,
                                                    flexBox.borderRadius2,
                                                    flexBox.margin05,
                                                    colors.bgPaper,
                                                )}
                                            >
                                                <Typography fontWeight={400} variant="subtitle2">
                                                    {hour[0]}h
                                                </Typography>
                                                <Typography fontWeight={400} variant="subtitle2">
                                                    -
                                                </Typography>
                                                <Typography fontWeight={400} variant="subtitle2">
                                                    {hour[1]}h
                                                </Typography>
                                            </Stack>
                                        ))}
                                    </Stack>
                                </Stack>
                            ))
                        ) : (
                            <Typography fontWeight={400} variant="subtitle2" noWrap>
                                {t('analytics.common.noData')}
                            </Typography>
                        )}
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    );
};

export default MyAvailabilityDetails;
